/**
 * `getAccessTokenSilently` rejects with a `@auth0/auth0-spa-js` `GenericError`,
 * which is NOT an instance of the `OAuthError` exported by `@auth0/auth0-react`.
 * Duck-type on the `error` code instead so the consent/login redirect actually fires.
 */
export const getAuth0ErrorCode = (error: unknown): string | undefined =>
  error !== null &&
  typeof error === 'object' &&
  'error' in error &&
  typeof error.error === 'string'
    ? error.error
    : undefined;
